// extracted by mini-css-extract-plugin
export default {"container":"VycTPn","video":"iaouJ0","videoQuote":"y_7nJv","oysterBackground":"PxzL0a","ctaPadding":"UgVoVr"};